module.exports = __webpack_public_path__ + "img/logo.dc62fbf9.png";